const shape = {
  borderRadiusSmall: '0.5rem',
  borderRadiusMedium: '0.75rem',
  borderRadius: '1rem',
  borderRadiusLarge: '2rem',
}

export default shape
